import { styled } from '@mui/material';
import { QueryBuilder } from '@procureai/query-builder-ui-mui';

export const QueryBuilderContainer = styled('div')(({ theme }) => ({
  overflowY: 'auto',
  maxHeight: '40%',
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
}));

export const QueryBuilderStyled = styled(QueryBuilder)({
  marginBottom: -30,
}) as typeof QueryBuilder;

export const ButtonWrap = styled('div')({
  display: 'flex',
  justifyContent: 'end',
  marginBottom: 10,
});

export const Root = styled('div')({
  position: 'relative',
  border: '1px solid red',
});
